import React, { Component } from "react";
import moment from "moment";
import { confirmAlert } from "react-confirm-alert";
import { patchResponse } from "../api/response";

export default class ResponsesTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filterNameOrPhone: undefined,
    };
  }

  onEditClick = (r) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return <ResponseEditor onClose={onClose} response={r} onSave={this.props.onEditResponse}/>;
      },
    });
  };

  render() {
    const filterNameOrPhone = this.state.filterNameOrPhone;

    var rows = filterNameOrPhone
      ? this.props.responses.filter((r) =>
          r.Recipient.name
            ? r.Recipient.name
                .toLowerCase()
                .includes(filterNameOrPhone.toLowerCase()) ||
              r.Recipient.phone.includes(filterNameOrPhone)
            : false
        )
      : this.props.responses;

    if (this.props.filterByAnswer) {
      if (this.props.filterByAnswer !== "Other Resp.") {
        rows = rows.filter((r) => r.text.includes(this.props.filterByAnswer) || r.text.split(/[ ,]+/).includes(this.props.filterByAnswer));
      } else {
        rows = rows.filter((r) => !this.props.expected.includes(r.text));
      }
    }

    const responseCell = (r) => {
      const style = {
        border: "none",
        backgroundColor: "transparent",
        cursor: "pointer",
      };

      const tooltipText = r.text !== r.originalText ? `Edited from '${r.originalText}'` : "";

      return (
        <button
          title={tooltipText}
          style={style}
          onClick={() => this.onEditClick(r)}
        >
          {r.text}
        </button>
      );
    };


    return (
      <div>
        <input
          className="input mb-2"
          type="text"
          placeholder="Filter by name or phone #"
          onChange={(e) => this.setState({ filterNameOrPhone: e.target.value })}
        />

        <div className="">
          <table className="table is-striped is-fullwidth">
            <thead>
              <tr>
                <th>Name</th>
                <th>Phone #</th>
                <th className="has-text-centered">Response</th>
                <th>Date/Time</th>
              </tr>
            </thead>

            <tbody>
              {rows.map((r) => (
                <tr key={r.id}>
                  <th>{r.Recipient.name || "Deleted Contact"}</th>
                  <th>{r.Recipient.phone || ""}</th>
                  <th className="has-text-centered">{responseCell(r)}</th>
                  <th>{moment(r.answeredAt).format("YYYY-MM-DD HH:mm:ss")}</th>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

class ResponseEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      text: this.props.response.text,
      isLoading: false
    };
  }

  onSave = () => {
    this.setState({isLoading: true})
    patchResponse(this.props.response.id, this.state.text).then((res) => {
      this.setState({isLoading: false})
      this.props.onSave()
      this.props.onClose()
    }).catch(() => this.setState({isLoading: false}));
  };

  render() {
    const resp = this.props.response;

    const renderOriginal = resp.text !== resp.originalText ? true : false;

    return (
      <div className="box recipient-selector">
        <div className="">
          <label className="label mb-4">Edit Response</label>

          {renderOriginal && (
            <>
              <p>Original Response:</p>
              <p className="has-text-weight-bold mb-4">{resp.originalText}</p>
            </>
          )}

          <p>Current Response:</p>
          <p className="has-text-weight-bold mb-4">{resp.text}</p>

          <p>New Response</p>

          <input
            className="input mt-2 mb-2"
            type="text"
            placeholder="Enter a response"
            onChange={(e) => this.setState({ text: e.target.value.toUpperCase() })}
            value={this.state.text}
          />

          <div className="buttons mt-4">
            <button
              className={`button is-primary is-small ${this.state.isLoading ? "is-loading" : ""}`}
              onClick={this.onSave}
            >
              Save
            </button>

            <button
              className="button is-info is-small"
              onClick={() => this.props.onClose()}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    );
  }
}
